const DEFAULT_TEXT_STYLE = {
    fontName: "GameFont",
    fill: 0xffffff,
    align: "center",
    textBaseline: "middle",
    fontSize: 64,
    lineHeight: 64,
    leading: 0,
    wordWrap: false,
    dropShadow: true,
    dropShadowAlpha: 0.75,
    dropShadowAngle: Math.PI * 0.6,
    dropShadowBlur: 1,
    dropShadowColor: 0x000000,
    dropShadowDistance: 2,
};

let measureTextInstance;
const measureTextCache = new Map();
function measureText(str) {
    if (!measureTextCache.has(str)){
        measureTextInstance = measureTextInstance || new PIXI.BitmapText(str, DEFAULT_TEXT_STYLE);
        measureTextInstance.text = str;
        let {textWidth, textHeight} = measureTextInstance;
        measureTextCache.set(str, {textWidth, textHeight});
    }
    return measureTextCache.get(str);
}

export class UIText extends PIXI.BitmapText {

    _rect = new PIXI.Rectangle(0, 0, 1, 1);

    get fill() {
        return this.tint;
    }

    set fill(val) {
        this.tint = val;
    }

    constructor(text = "", style = DEFAULT_TEXT_STYLE) {
        style = Object.assign({}, DEFAULT_TEXT_STYLE, style || {});
        super(text, style);
        this.anchor.set(0.5);

        let {
            fontSize = 64,
            autoFitPadding = 0,
            fitTextTemplate = "",
            wordWrap = false,
            fill = DEFAULT_TEXT_STYLE.fill
        } = (style || {});

        this.autoFitProps = {autoFitPadding, fitTextTemplate, wordWrap};
        this.fill = fill;
        this.initialFontSize = fontSize;
    }

    _fitLayoutMultiline() {
        let rect = this._rect.clone().pad(-this.autoFitProps.autoFitPadding || 0);
        this.position.set(
            rect.x + rect.width * this.anchor.x,
            rect.y + rect.height * this.anchor.y,
        );
        this.maxWidth = rect.width;
        this.fontSize = this.initialFontSize;
        if (rect.height < this.textHeight) {
            this.fontSize *= Math.min(1, rect.height / this.textHeight)
        }
    }

    fitLayout(rect = this._rect) {
        this._rect = rect.clone();

        if (this.autoFitProps.wordWrap) {
            return this._fitLayoutMultiline();
        }

        this.maxWidth = 0;
        rect = this._rect.clone().pad(-this.autoFitProps.autoFitPadding || 0);

        let {textWidth, textHeight} = this;
        if (this.autoFitProps.fitTextTemplate) {
            let size = measureText(this.autoFitProps.fitTextTemplate);
            textWidth = size.textWidth;
            textHeight = size.textHeight;
        }

        this.scale.set(Math.min(
            1,
            rect.width / textWidth,
            rect.height / textHeight
        ));

        this.position.set(
            rect.x + rect.width * this.anchor.x,
            rect.y + rect.height * this.anchor.y,
        );

        // XXX: fix incorrect text height without bottom padding
        this.y -= (this.getLocalBounds().height - this.textHeight) * 0.5 * this.scale.y;

        // this._g = this._g || this.addChild(new PIXI.Graphics);
        // this._g.clear()
        //     .lineStyle(2, 0xFF0000).drawRect(
        //         (rect.x - this.x) / this.scale.x,
        //         (rect.y - this.y) / this.scale.y,
        //         rect.width / this.scale.x,
        //         rect.height / this.scale.y
        //     )
        // ;
    }
}
